import { IUserListVM } from '../../models/response/IUserResponse';

const initialState: IUserListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  Users: [],
};

export default initialState;
